export default __webpack_public_path__ + "static/media/pepsico-viverbem.633cc550.png";